export const fptiConstants = {
    FPTI_SETUP: 'FPTI_SETUP',
    FPTI_TRACKING: 'FPTI_TRACKING'
};

export const apiConstants = {
    CHECK_ACCOUNT_EXISTENCE_ERROR: 'CHECK_ACCOUNT_EXISTENCE_ERROR',
    UPGRADE_ACCOUNT_ERROR: 'UPGRADE_ACCOUNT_ERROR',
    UNAUTHORIZED_ERROR: 'UNAUTHORIZED_ERROR',
    FORBIDDEN_ERROR: 'FORBIDDEN_ERROR'
};

export const addressSuggestionConstants = {
    KEYDOWN_EVENT_ERROR: 'KEYDOWN_EVENT_ERROR'
};
